import { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import getBlogPosts from '../../api/getBlogPosts';
import Layout from '../../ui/layout';
import List from '../../ui/blog/list';

const POSTS_PER_PAGE = 12;

const loadPosts = async (page) => {
  try {
    const { total, posts } = await getBlogPosts({
      page,
      limit: POSTS_PER_PAGE,
    });

    return {
      posts,
      total,
      hasError: false,
    };
  } catch (e) {
    return {
      posts: null,
      total: null,
      hasError: true,
    };
  }
};

const fetchFirstPage = async () => {
  const page = 1;

  const { posts, total, hasError } = await loadPosts(page);

  return {
    posts,
    page,
    total,
    hasError,
  };
};

class ListPage extends Component {
  static async getInitialProps() {
    const { posts, total, page, hasError } = await fetchFirstPage();

    return {
      posts,
      total,
      page,
      hasError,
    };
  }

  constructor(props) {
    super(props);

    const { posts, page, total, hasError } = props;

    this.state = {
      posts,
      page,
      total,
      hasError,
      isLoading: false,
    };
  }

  loadFirstPage = async () => {
    const data = await fetchFirstPage();
    this.setState(data);
  };

  loadNextPage = async () => {
    const { posts, page } = this.state;

    const nextPage = page + 1;

    this.setState({
      isLoading: true,
    });

    const { posts: nextPosts } = await loadPosts(nextPage);

    this.setState({
      posts: [...posts, ...nextPosts],
      page: nextPage,
      isLoading: false,
    });
  };

  hasNextPage() {
    const { total, page } = this.state;
    return total > page;
  }

  render() {
    const { posts, isLoading, hasError } = this.state;

    return (
      <Layout>
        <Head>
          <title>EyeFitU fashion trends blog</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>
        <List
          posts={posts}
          isLoading={isLoading}
          hasError={hasError}
          loadNextPage={() => this.loadNextPage()}
          hasNextPage={this.hasNextPage()}
        />
      </Layout>
    );
  }
}

ListPage.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  page: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  hasError: PropTypes.bool.isRequired,
};

export default ListPage;
